import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/payment`;

// Création d'une session Stripe pour un plan tarifaire Judo Coach Pro
export const createCheckoutSessionForPlan = async (plan, userId) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("Utilisateur non authentifié. Veuillez vous connecter.");
  }

  if (!plan?.formule || !userId) {
    throw new Error("Formule ou utilisateur manquant pour créer la session Stripe.");
  }

  try {
    const response = await axios.post(
      `${apiUrl}/create-checkout-session/plan`,
      {
        formule: plan.formule,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data.url;
  } catch (error) {
    console.error("Erreur création session Stripe plan :", {
      status: error?.response?.status,
      data: error?.response?.data,
      url: error?.config?.url,
      method: error?.config?.method,
    });

    throw error;
  }
};